var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOptionGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ADBABD",
    strokeMiterlimit: 10,
    strokeWidth: 65
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 82.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 512,
    r: 82.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.5,
    cy: 512,
    r: 82.8
  }))));
}

export default SvgOptionGray;